/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { RouteComponentProps } from 'react-router';
import { oc } from 'ts-optchain';

export interface Page {
  path: string;
  invalidIf(props: any): boolean;
  shouldShow(props: any): boolean;
}

interface ExternalProps extends RouteComponentProps<any> {
  currentPage: Page;
  nextPage: Page;
  prevPage: Page;
}

export interface FlowProps extends RouteComponentProps<any> {
  nextRoute: string;
  prevRoute: string;
}

export default <TOriginalProps extends {}>(
  WrappedComponent: React.ComponentType<TOriginalProps & FlowProps>
) => {
  type FinalProps = TOriginalProps & ExternalProps;
  class UIFlowComponent extends React.Component<FinalProps> {
    static displayName: string;

    render(): EmotionJSX.Element {
      const { history, location, match, staticContext } = this.props;
      const flowProps: FlowProps = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        nextRoute: oc(this.props.nextPage).path()!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        prevRoute: oc(this.props.prevPage).path()!,
        history,
        location,
        match,
        staticContext,
      };

      // The any comes from a bad interaction between emotion and react types.
      // See: https://github.com/emotion-js/emotion/issues/2169
      /* eslint-disable  @typescript-eslint/no-explicit-any */
      return <WrappedComponent {...(this.props as any)} {...flowProps} />;
    }
  }

  const wrappedComponentName = UIFlowComponent.displayName || UIFlowComponent.name || 'Component';
  UIFlowComponent.displayName = `uiFlowComponent(${wrappedComponentName})`;
  return UIFlowComponent;
};
